import { render, staticRenderFns } from "./CardTarjaEnqueteAngelicaQRCODE.vue?vue&type=template&id=6a6a40fe&scoped=true"
import script from "./CardTarjaEnqueteAngelicaQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteAngelicaQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteAngelicaQRCODE.vue?vue&type=style&index=0&id=6a6a40fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a40fe",
  null
  
)

export default component.exports